import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CustomCssAnimation from './CustomCssAnimation';

//////////////////////////

const useStyles = makeStyles( theme => ({

  default: {
    transform: 'scale(1)',
  },

  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '50%': { transform: 'rotate(180deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },

  transitions: {
    '&.entering': {
      animation: '$spin 250ms linear infinite'
    },
    '&.entered': {
      animation: '$spin 250ms linear infinite'
    },
    '&.exiting': {
      transform: 'translate(0)',
    },
    '&.exited': {
      transform: 'translate(0)',
    },
  },

}));

//////////////////////////

const defaultProps = {
  delay: 0,
  duration: 1000,
  id: "spin",
}

export const AnimateSpin = props => {

  const {id} = props;
  
  //////

  return (

    <CustomCssAnimation
      {...props}
      id = {id}
      useStyles = {useStyles}
    >
      {props.children}
    </CustomCssAnimation>

  );

};

AnimateSpin.defaultProps = defaultProps;
export default AnimateSpin;
